import { computed } from 'mobx';
import { ViewController } from 'elc-service';
import { ZoomViewBaseController } from './ZoomViewBaseController';

export class ProductZoomViewController extends ViewController {
    private zoomViewBaseController: ZoomViewBaseController;

    constructor(zoomViewBaseController: ZoomViewBaseController) {
        super();
        this.zoomViewBaseController = zoomViewBaseController;
    }

    @computed
    get data() {
        return {
            isZoomActive: this.isZoomActive,
            currentZoomSlideIndex: this.currentZoomSlideIndex
        };
    }

    @computed
    public get isZoomActive(): boolean {
        return this.zoomViewBaseController.isZoomActive;
    }

    @computed
    public get currentZoomSlideIndex(): number {
        return this.zoomViewBaseController.currentZoomSlideIndex;
    }

    public setCurrentZoomSlideIndex = (currentZoomSlideIndex: number = 0) => {
        this.zoomViewBaseController.setCurrentZoomSlideIndex(currentZoomSlideIndex);
    };

    public closeZoom = () => {
        this.zoomViewBaseController.closeZoom();
    };
}
